import HandleUpdateText from "../../../utils/HandleUpdateText";

const InputLiveUpdater = ({value, field, placeholder, route, id, debounceUpdate, setElements, width = "w-full"}) => {
  return (
    <input
      type="text"
      value={value}
      onChange={(e) => HandleUpdateText(field, e.target.value, id, route, debounceUpdate, setElements)}
      placeholder={placeholder}
      className={`${width} px-2 py-1 text-xs border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-blue-500`}
    />
  )
}

export default InputLiveUpdater;